import { Duration } from "luxon";
export default function format(_ref) {
  var alternativeName = _ref.alternativeName,
    mainCities = _ref.mainCities,
    rawOffsetInMinutes = _ref.rawOffsetInMinutes,
    currentTimeOffsetInMinutes = _ref.currentTimeOffsetInMinutes;
  var _ref2 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
    _ref2$useCurrentOffse = _ref2.useCurrentOffset,
    useCurrentOffset = _ref2$useCurrentOffse === void 0 ? false : _ref2$useCurrentOffse;
  var offsetInHours = useCurrentOffset ? getOffsetString(currentTimeOffsetInMinutes) : getOffsetString(rawOffsetInMinutes);
  return "".concat(offsetInHours.padStart(6, "+"), " ").concat(alternativeName, " - ").concat(mainCities.join(", "));
}
function getOffsetString(offsetInMinutes) {
  var durationInHoursMinutes = Duration.fromObject({
    minutes: Math.abs(offsetInMinutes)
  }).toFormat("hh:mm");
  return "".concat(offsetInMinutes >= 0 ? "+" : "-").concat(durationInHoursMinutes);
}